import React, { FunctionComponent, useState, useEffect } from "react";
import Modal from "react-modal";
import styles from "./AddResourceModal.module.css";
import { IoIosClose } from "react-icons/io";
import { connect, useDispatch } from "react-redux";
import {themeColors} from "../../theme";
import { motion,AnimatePresence } from "framer-motion";
import Backdrop from "../../Backdrop/Backdrop";
import InputWithAutoComplete from "../../DropDown/InputWithAutoComplete";
import { showSnackbarAction } from "../../../Redux/actions";

type props = {
  open: boolean;
  close: () => void;
  heading: string;
  title: string;

  onSave: (v: any) => void;
  type: string,
  theme:any;
  constants: any;
};

const dropIn = {
  hidden: {
    y: "-100vh",
    opacity: 1,
  },
  visible: {
    y: "0",
    opacity: 1,
    transition: {
      duration: 1,
      type: "spring",
      damping: 25,
      stiffness: 500,
    },
  },
};

const EditResources: FunctionComponent<props> = ({
  open,
  close,
  heading,
  title,
  onSave,
  type,
  theme,
  constants,
}) => {
  const [value, setValue] = useState(title);
  const [leadSources, setLeadSources] = useState();
  const dispatcher = useDispatch();

  const constant = async () => {
    const leadSources = constants.leadSources;
    setLeadSources(leadSources);
  };

  useEffect(() => {
    // console.log("loa",heading,heading.split(" ")[1])
    if (constants) {
      constant();
    }
  }, []);

  const editResource = (editValue: any) => {
    if (editValue.trim() === "" || editValue === undefined || editValue === null) {
      dispatcher(showSnackbarAction("Please enter value", "error"));
      return;
    }
    else{
    onSave(editValue.trim());
  }
  };

  const containerStyles ={ backgroundColor:theme ? themeColors.backgroundColor:themeColors.backgroundColorDark,color:theme ? themeColors.textPrimary:themeColors.textPrimaryDark} 
  return (
    // <Modal
    //   isOpen={open}
    //   className={styles.parent}
    //   overlayClassName={styles.overlay}
    //   onRequestClose={close}
    //   shouldCloseOnOverlayClick={true}
    //   shouldCloseOnEsc={true}
    //   style={customStyles}
    // >
    //      <div className={styles.headingContainer}>
    //      <h5 
    //     //  className={styles.heading}
    //      >{heading}</h5>
    //      <div className={styles.icon} onClick={close}>
    //     <IoIosClose size={35} color={"#808080"} />
    //   </div>
    //      </div>
    //   {/* <div className={styles.icon} onClick={close}>
    //     <IoIosClose size={35} color={"#808080"} />
    //   </div>
    //   <p className={styles.heading}>{heading}</p> */}
    //   <div className={styles.nameBox}>
    //     {/* <span className={styles.name}>{`Enter ${heading.split(" ")[1]}`}</span> */}
    //     <h6>{`Enter ${heading.split(" ")[1]}`}</h6>
    //     <input
    //       className={styles.input}
    //       onChange={(event) => setValue(event.target.value)}
    //       value={value}
    //     />
    //   </div>
    //   <div className={styles.button}>
    //     <button className={styles.cancel} onClick={close}>
    //       Cancel
    //     </button>
    //     <button className={styles.change} onClick={() => onSave(value)}>
    //       Save
    //     </button>
    //   </div>
    // </Modal>
      <Backdrop>
         <motion.div
       key="modal"
       className="card p-4 shadow rounded"
       style={{position: "absolute",
       ...containerStyles}}
       variants={dropIn}
       initial="hidden"
       animate="visible"
       exit="exit"
     >
        <div className={styles.headingContainer}>
         <h5 
        //  className={styles.heading}
         >{heading}</h5>
         {/* <div className={styles.icon} onClick={close}>
        <IoIosClose size={35} color={"#808080"} />
      </div> */}
         </div>
      {/* <div className={styles.icon} onClick={close}>
        <IoIosClose size={35} color={"#808080"} />
      </div>
      <p className={styles.heading}>{heading}</p> */}
      <div className={styles.nameBox}>
        {/* <span className={styles.name}>{`Enter ${heading.split(" ")[1]}`}</span> */}
        <h6>{`Enter ${heading.split(" ")[1]}`}</h6>
        {
          type !== "Lead Source" &&
          <input
          // className={styles.input}
          className="form-control"
          style={{  flex: 1,fontSize:"14px"}}
          onChange={(event) => setValue(event.target.value)}
          value={value}
        />
        }
        {type == "Lead Source" && <InputWithAutoComplete value={value} options={leadSources} setValue={(val:any)=>{setValue(val)}} />}
      </div>
      <div className={styles.button}>
      <button className={styles.change} onClick={() => editResource(value)}>
          Save
        </button>
        <button className={styles.cancel} onClick={close}>
          Cancel
        </button>
      </div>
     </motion.div>
      </Backdrop>
  );
};

const mapStateToProps = (state: any) => {
  return {
    user: state.user.data,
    contacts: state.contacts,
    theme: state.theme.isLightMode,
    constants:state.constants.data,
  };
};

export default connect(mapStateToProps)(EditResources);
